import React, { useState } from 'react';

const GozIkonu = ({ goster }) => goster
  ? <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
  : <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>;

const sifreGuc = (sifre) => {
  if (!sifre) return { puan: 0, renk: 'var(--gri-200)', etiket: '' };
  let puan = 0;
  if (sifre.length >= 8) puan++;
  if (/[A-Z]/.test(sifre)) puan++;
  if (/[a-z]/.test(sifre)) puan++;
  if (/[0-9]/.test(sifre)) puan++;
  if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(sifre)) puan++;
  
  if (puan <= 1) return { puan, renk: 'var(--kirmizi)', etiket: 'Cok Zayif' };
  if (puan === 2) return { puan, renk: 'var(--turuncu, #f97316)', etiket: 'Zayif' };
  if (puan === 3) return { puan, renk: 'var(--sari)', etiket: 'Orta' };
  if (puan === 4) return { puan, renk: 'var(--mavi)', etiket: 'Iyi' };
  return { puan, renk: 'var(--yesil)', etiket: 'Guclu' };
};

const PasswordInput = ({ value, onChange, placeholder, required, minLength, style, showStrength, ...props }) => {
  const [goster, setGoster] = useState(false);
  const guc = showStrength ? sifreGuc(value) : null;
  
  return (
    <div>
      <div style={{ position: 'relative' }}>
        <input
          type={goster ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          minLength={minLength || 8}
          style={{ ...style, paddingRight: '2.5rem', width: '100%', boxSizing: 'border-box' }}
          {...props}
        />
        <button type="button" onClick={() => setGoster(!goster)}
          style={{ position: 'absolute', right: '0.5rem', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--yazi-ikincil)', padding: '4px', display: 'flex', alignItems: 'center' }}>
          <GozIkonu goster={goster} />
        </button>
      </div>
      {showStrength && value && (
        <div style={{ marginTop: '6px' }}>
          <div style={{ display: 'flex', gap: '4px', marginBottom: '4px' }}>
            {[1,2,3,4,5].map(i => (
              <div key={i} style={{ flex: 1, height: '4px', borderRadius: '99px', background: i <= guc.puan ? guc.renk : 'var(--gri-200)', transition: 'background 0.3s' }} />
            ))}
          </div>
          {guc.etiket && <p style={{ fontSize: '11px', color: guc.renk, fontWeight: '500' }}>{guc.etiket}</p>}
          {guc.puan < 5 && (
            <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)', marginTop: '4px' }}>
              {!value || value.length < 8 ? '• En az 8 karakter ' : ''}
              {!/[A-Z]/.test(value) ? '• Buyuk harf ' : ''}
              {!/[0-9]/.test(value) ? '• Rakam ' : ''}
              {!/[!@#$%^&*]/.test(value) ? '• Ozel karakter (!@#$%^&*)' : ''}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PasswordInput;
